import {Api} from '../../../Api.js'

const RESOURCE = 'agenda'

export default {
    resource: RESOURCE,
    query(query) {
        return Api().get(this.resource + (query ? query : ''))
    },
    getOpenings(id, start, end) {
        return Api().get(this.resource + '/openings/' + id + '?start=' + start + '&end=' + end)
    },
    updateOpening(data) {
        return Api().post(this.resource + '/opening', data)
    },
    get(id) {
        return Api().get(this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.resource, data)
    },
    update(id, data) {
        return Api().put(this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/config/agenda/AgendaService.js